export const APP_MESSAGES = {
  general: {
    VERIFY_REQUEST_RETRY_MESSAGE: 'Please verify your request and try again.',
    UNKNOWN_USER_MESSAGE: 'Unknown User',
    NO_ROLE_AVAILABLE_MESSAGE: 'No role available',
    CURRENT_USER_UNAVAILABLE_ERROR:
      'Unable to identify current user. Please sign in again and retry.',
    DEFAULT_ERROR_TITLE: 'Something went wrong!',
    DEFAULT_SUCCESS_TITLE: 'Success!',
    DEFAULT_INFO_TITLE: 'Info!',
    DEFAULT_WARNING_TITLE: 'Warning!',
  },
  dashboard: {
    POWER_BI_CONFIG_NOT_AVAILABLE_ERROR: 'Power BI configuration data is not available in Governx.',
    ACTION_PORTAL_CONFIG_NOT_AVAILABLE_ERROR:
      'Action Portal configuration data is not available in Governx.',
    EXPORT_INSIGHTS_METRICS_LOAD_ERROR:
      'Unable to load metrics for the selected card. Please try again.',
    EXPORT_INSIGHTS_PREVIEW_LOAD_ERROR:
      'Unable to load preview records for the selected card. Please try again.',
    NO_REPORTS_FOUND_MESSAGE: 'No Power BI reports found.',
  },
  help: {
    IMPERSONATE_LOADING_USERS_MESSAGE: 'Loading users...',
    IMPERSONATE_NO_USERS_MESSAGE: 'No users available for impersonation.',
  },
  header: {
    CREATE_ACTION_LABEL: 'Create',
    CREATE_RAID_FORM_LABEL: 'Create RAID Form',
    SUBMIT_INVOICE_LABEL: 'Submit Invoice',
    SELECT_FORM_HELP_MESSAGE: 'Select the form from the list',
  },
  actions: {
    UPLOAD_TARGET_MISSING_ERROR:
      'Upload target is missing. Please reopen attachments and try again.',
    UPLOAD_SUCCESS_MESSAGE: 'File uploaded successfully.',
    UPLOAD_SUCCESS_TITLE: 'Upload Completed',
    UPLOAD_FAILED_MESSAGE: 'Unable to upload file. Please try again.',
    UPLOAD_FAILED_TITLE: 'Upload Failed',
    FILE_ALREADY_EXIST_ERROR: 'File already exist.',
    EXPORT_EMPTY_FILE_RESPONSE_ERROR: 'Export API returned an empty file response.',
    EXPORT_MISSING_FILE_NAME_ERROR: 'Export API did not provide a download filename.',
    DOWNLOAD_EMPTY_FILE_RESPONSE_ERROR: 'Download API returned an empty file response.',
    DOWNLOAD_ZIP_MISSING_FILE_NAME_ERROR: 'Download zip API did not provide a download filename.',
    DOWNLOAD_SINGLE_MISSING_FILE_NAME_ERROR:
      'Single attachment API did not provide a download filename.',
    DOWNLOAD_GENERIC_FAILURE_ERROR: 'Unable to download file. Please try again.',
    DOWNLOAD_FAILURE_TITLE: 'Download Failed',
    DELETE_ATTACHMENT_MISSING_CONTEXT_ERROR:
      'Unable to remove attachment. Attachment ID is missing. Please refresh and try again.',
    DELETE_ATTACHMENT_FAILED_MESSAGE: 'Unable to remove attachment. Please try again.',
    DELETE_ATTACHMENT_FAILED_TITLE: 'Remove Failed',
    DELETE_ATTACHMENT_SUCCESS_MESSAGE: 'Attachment removed successfully.',
    DELETE_ATTACHMENT_SUCCESS_TITLE: 'Attachment Removed',
    NO_RECORDS_FOUND_MESSAGE: 'No records found.',
    LOAD_ACTION_INSIGHTS_ERROR: 'Unable to load action insights.',
    LOAD_PRIORITY_ACTIONS_ERROR: 'Unable to load priority actions.',
    PRIORITY_ACTIONS_LOADING_MESSAGE: 'Loading priority actions...',
    NO_PRIORITY_ACTIONS_AVAILABLE_MESSAGE: 'No priority actions available.',
    CLARIFY_FORM_LOADING_MESSAGE: 'Loading clarify form...',
    CLARIFY_FORM_LOAD_ERROR: 'Unable to load clarify form.',
    INVOICE_FORM_LOADING_MESSAGE: 'Loading invoice form...',
    INVOICE_FORM_LOAD_ERROR: 'Unable to load invoice form.',
    INVOICE_DATE_ORDER_ERROR: 'Start date should be less than end date.',
    SUBMIT_INVOICE_UNAVAILABLE_ERROR:
      'Submit an Invoice process is unavailable. Please refresh and try again.',
    SUBMIT_INVOICE_UNAVAILABLE_TITLE: 'Invoice Submission Unavailable',
    CLARIFICATION_SOURCE_MISSING_ERROR: 'Source is missing for the selected clarification record.',
    CLARIFICATION_RECORDS_LOADING_MESSAGE: 'Loading clarification records...',
    CLARIFICATION_RECORDS_ERROR: 'Unable to load clarification records.',
    CLARIFICATION_RECORDS_EMPTY_MESSAGE: 'No clarification records found',
    PREFERENCES_INCOMPLETE_ERROR:
      'Preference details are incomplete. Please refresh and try again.',
    SAVE_PREFERENCES_FAILED_TITLE: 'Save Preferences Failed',
    BULK_REQUEST_INCOMPLETE_MESSAGE_SUFFIX:
      'request details are incomplete. Please refresh and try again.',
    SUBMISSION_GENERIC_FAILURE_ERROR: 'Unable to complete approval. Please try again.',
    INVOICE_SUMMARY_LOADING_MESSAGE: 'Loading invoice summary...',
    INVOICE_SUMMARY_ERROR: 'Unable to load invoice summary.',
    INVOICE_SUMMARY_EMPTY_MESSAGE: 'No invoice summary found',
    INVOICE_REQUEST_INCOMPLETE_ERROR:
      'Invoice request details are incomplete. Please fill all required fields and try again.',
    INVOICE_SUBMISSION_FAILED_TITLE: 'Invoice Submission Failed',
    INVOICE_USER_CONTEXT_UNAVAILABLE_ERROR:
      'Unable to resolve username/sys_id for invoice submission. Please sign in again and retry.',
    CLARIFICATION_REQUEST_INCOMPLETE_ERROR:
      'Clarification request details are incomplete. Please refresh and try again.',
    CLARIFICATION_FAILED_TITLE: 'Clarification Failed',
    EXPORT_MISSING_TABLE_METADATA_ERROR:
      'Unable to export because table metadata is missing. Please refresh and try again.',
    EXPORT_MISSING_CONDITION_METADATA_ERROR:
      'Unable to export because filter condition metadata is missing. Please refresh and try again.',
    EXPORT_MISSING_VIEW_METADATA_ERROR:
      'Unable to export because view metadata is missing. Please refresh and try again.',
    EXPORT_FAILED_TITLE: 'Export Failed',
    EXPORT_NETWORK_ERROR:
      'Network error while downloading records. Please check your connection and retry.',
    EXPORT_GENERIC_ERROR: 'Unable to download table records. Please try again.',
    ATTACHMENTS_EMPTY_MESSAGE: 'No attachments found',
    DOWNLOAD_NO_ATTACHMENTS_ERROR: 'No attachments available for download.',
    DOWNLOAD_MULTI_ATTACHMENTS_ONLY_ZIP_ERROR:
      'Multiple attachments must be downloaded using backend ZIP API.',
    DOWNLOAD_URL_UNAVAILABLE_ERROR: 'Attachment download URL is unavailable.',
    DOWNLOAD_NON_FILE_PAYLOAD_ERROR: 'Attachment endpoint returned non-file payload.',
  },
  delegation: {
    DELEGATE_REQUIRED_ERROR: 'Delegate is required.',
    START_DATE_REQUIRED_ERROR: 'Start date is required.',
    END_DATE_REQUIRED_ERROR: 'End date is required.',
    INVALID_START_DATE_ERROR: 'Invalid start date format.',
    INVALID_END_DATE_ERROR: 'Invalid end date format.',
    DATE_RANGE_ORDER_ERROR: 'Start date should be less than or equal to end date.',
    SCOPE_REQUIRED_ERROR: 'At least one delegation scope is required.',
    SUCCESS_TITLE: 'Delegated Successfully!',
    DELEGATED_LIST_LOAD_ERROR: 'Unable to load delegated records. Please try again.',
  },
  createForm: {
    LOAD_METADATA_FAILED_ERROR: 'Unable to load dynamic form metadata. Please try again.',
    SUBMIT_SUCCESS_TITLE: 'Risk Created',
    SUBMIT_SUCCESS_MESSAGE: 'Risk form submitted successfully.',
    SUBMIT_FAILED_MESSAGE: 'Unable to submit risk form. Please review your values and retry.',
    SUBMISSION_GENERIC_FAILURE_ERROR: 'Unable to complete submission. Please try again.',
    SUBMIT_FAILED_TITLE: 'Risk Submit Failed',
    SUBMISSION_FAILED_TITLE: 'Submission Failed',
  },
  exportInsights: {
    PREVIEW_EMPTY_TITLE: 'No Records Found',
    PREVIEW_EMPTY_DESCRIPTION_MESSAGE: 'No data is available for the selected table and filters.',
  },
  transactionHistory: {
    TIMELINE_EMPTY_MESSAGE: 'No Activity Time Line',
    EMAIL_LOGS_EMPTY_MESSAGE: 'No records found.',
  },
  cockpit: {
    SUMMARY_LOADING_MESSAGE: 'Loading AI Cockpit summary...',
    EMPTY_STATE_MESSAGE:
      'AI Cockpit insights are loading. Summary cards will appear here when data becomes available.',
  },
  filters: {
    NO_RESULTS_MESSAGE: 'No results',
  },
  waiveOff: {
    COMMENTS_PROMPT_MESSAGE: 'Please add Waive Off comments',
  },
  forms: {
    FIELD_REQUIRED_MESSAGE_SUFFIX: 'is required.',
    START_DATE_LESS_THAN_END_DATE_ERROR: 'Start Date should be less than End Date.',
    END_DATE_GREATER_THAN_START_DATE_ERROR: 'End Date should be greater than Start Date.',
    RISK_OWNER_CLOSING_APPROVER_DIFFER_ERROR: 'Risk Owner and Closing Approver should not be same.',
    ACTION_OWNER_CLOSING_APPROVER_DIFFER_ERROR:
      'Action Owner and Closing Approver should not be same.',
    ISSUE_OWNER_CLOSING_APPROVER_DIFFER_ERROR:
      'Issue Owner and Closing Approver should not be same.',
    DECISION_OWNER_FINAL_APPROVER_DIFFER_ERROR:
      'Decision Owner and Final Approver should not be same.',
  },
} as const;
